import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Eyebrow } from "../../components/bits";
import { ArrowRight, Sparkles } from "lucide-react";

const priceLabel = (it) => {
  if (it.unit === "quote" || it.from_price) return `from £${it.price}`;
  if (it.unit === "per_hour") return `£${it.price}/hr${it.min_hours ? ` · min ${it.min_hours}h` : ""}`;
  return `£${it.price}`;
};

export default function Specialist() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/specialist/services").then(({ data }) => setData(data)).catch(() => {}); }, []);
  const std = data?.standard_pricing || {};
  return (
    <div data-testid="specialist-page">
      <section className="bg-[#0a0a0a] relative">
        <div className="absolute inset-0 noise-overlay" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-16">
          <Eyebrow dark>Specialist Cleaning</Eyebrow>
          <h1 className="font-display text-[#fdfbf7] text-5xl sm:text-6xl tracking-tight max-w-3xl leading-[1.05]">Specialist services, finished to an exacting standard</h1>
          <p className="text-[#cfcabf] mt-5 max-w-2xl">Add a specialist service to a clean or book it on its own — ovens, fridges, carpets, mattresses, curtains, upholstery, interior windows and full home organisation. Fixed prices where we can; a tailored quotation where scope requires it.</p>
          <div className="mt-7 flex gap-3 flex-wrap">
            <Link to="/book" className="btn-gold px-7 py-3 rounded-sm text-sm" data-testid="specialist-book-cta">Book a clean with add-ons</Link>
            <Link to="/quote" className="btn-outline-gold-dark px-7 py-3 rounded-sm text-sm">Request a quote</Link>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="bg-[#faf9f5] border border-[#e8e5de] rounded-sm p-6 mb-12">
          <p className="text-[11px] tracking-luxe uppercase text-[#b5952f] mb-3">Standard hourly cleaning · Essential & Premium min 3h · Elite Signature min 4h</p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[["Essential", std.Essential, 3], ["Premium", std.Premium, 3], ["Elite Signature", std.Elite, 4]].map(([n, p, mh]) => (
              <div key={n} className="bg-white border border-[#e8e5de] rounded-sm p-5">
                <p className="font-display text-xl">{n}</p>
                <p className="text-[#b5952f] font-display text-3xl mt-1">£{p}<span className="text-sm text-[#8a8a8a]">/hour</span></p>
                <p className="text-xs text-[#8a8a8a] mt-1">Min {mh} hours</p>
              </div>
            ))}
          </div>
        </div>

        {!data && <p className="text-[#8a8a8a]">Loading services…</p>}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {data?.categories.map((cat) => (
            <div key={cat.category} className="bg-white border border-[#e8e5de] rounded-sm overflow-hidden" data-testid={`specialist-cat-${cat.category.replace(/\s|&/g, "-")}`}>
              <div className="bg-[#0a0a0a] px-6 py-4 flex items-center gap-2">
                <Sparkles size={16} className="text-[#d4af37]" />
                <h3 className="font-display text-[#fdfbf7] text-xl">{cat.category}</h3>
              </div>
              <div className="p-6 space-y-2.5">
                {cat.items.map((it) => (
                  <div key={it.key} className="flex justify-between items-baseline border-b border-[#f0efe9] pb-2.5">
                    <span className="text-sm">{it.name}{it.suitability_required && <span className="text-[10px] text-[#b5952f] ml-2 uppercase tracking-wide">assessment</span>}</span>
                    <span className="font-medium text-[#0a0a0a] whitespace-nowrap">{priceLabel(it)}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-[#8a8a8a] text-sm mt-10 max-w-3xl">Items marked <b>from</b> or <b>assessment</b> are individually assessed — for carpets, mattresses, curtains and upholstery we carry out a quick suitability check (fabric, condition, care guidance). Delicate, antique, silk, velvet, leather or dry-clean-only items are referred for specialist assessment. You'll always see and approve the final price before any payment is taken.</p>
      </section>
    </div>
  );
}
